export const ReplyIcon = ({
  size = 18,
  color = "#ACB3B9",
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 16 18"
  >
    <path
      fill="#ACB3B9"
      stroke={color}
      strokeLinecap="round"
      strokeWidth="0.5"
      d="M6.471 5.138a.667.667 0 00-.942-.943L2.195 7.53a.667.667 0 000 .942l3.334 3.334a.667.667 0 10.942-.943L4.276 8.667H8c1.534 0 2.697.458 3.468 1.16.768.698 1.199 1.68 1.199 2.84v2.666a.667.667 0 001.333 0v-2.666c0-1.508-.57-2.858-1.635-3.827C11.303 7.875 9.8 7.333 8 7.333H4.276l2.195-2.195z"
    />
  </svg>
);
